import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu, CircularProgress, Badge } from "@material-ui/core";
import TicketParticipantsModal from "../TicketParticipantsModal";
import {
  DeviceHubOutlined,
  History,
  MoreVert,
  PictureAsPdf,
  Replay,
  SwapHorizOutlined,
  AccountBalanceWallet,
  FileCopy as FileCopyIcon,
  FlashOn,
  Group as GroupIcon,
  Assessment as AssessmentIcon,
  PersonAddDisabled as PersonAddDisabledIcon,
  Visibility as VisibilityIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  NotificationsActive as NotificationsActiveIcon,
  NotificationsOff as NotificationsOffIcon,
} from "@material-ui/icons";
import { v4 as uuidv4 } from "uuid";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import Button from "@material-ui/core/Button";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

//icones
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import UndoIcon from "@material-ui/icons/Undo";

import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import toastUtils from "../../utils/toastUtils";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";
import { useTheme } from "@material-ui/styles";
import { useTimeMonitoring } from "../../hooks/useTimeMonitoring";

import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import QuickMessageModal from "../QuickMessageModal";
import VoiceAssistantButton from "../VoiceAssistantButton";
import GroupSummaryModal from "../GroupSummaryModal";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginRight: 6,
    maxWidth: "100%",
    flex: "none",
    alignSelf: "center",
    marginLeft: "auto",
    // flexBasis: "50%",
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  bottomButtonVisibilityIcon: {
    padding: 1,
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  botoes: {
    display: "flex",
    padding: "15px",
    justifyContent: "flex-end",
    maxWidth: "100%",
    // alignItems: "center"
  },
}));

const SessionSchema = Yup.object().shape({
  ratingId: Yup.string().required("Avaliação obrigatória"),
});

const TicketActionButtonsCustom = ({
  ticket,
  contact,
  onQuickMessageSelect,
  onOpenDrawer,
  isOtherUserTicket,
  chatUnlocked,
  onToggleChatLock,
  // , showSelectMessageCheckbox,
  // selectedMessages,
  // forwardMessageModalOpen,
  // setForwardMessageModalOpen
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
  
  // Time monitoring hook para validação de limites
  const { canAcceptTicket } = useTimeMonitoring();
  const [open, setOpen] = React.useState(false);
  const formRef = React.useRef(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [participantsModalOpen, setParticipantsModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(null);
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [disableBot, setDisableBot] = useState(ticket.contact.disableBot);
  const [groupSummaryModalOpen, setGroupSummaryModalOpen] = useState(false);

  const [showSchedules, setShowSchedules] = useState(false);
  const [enableIntegration, setEnableIntegration] = useState(
    ticket.useIntegration
  );

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [logTicket, setLogTicket] = useState([]);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const [showTestButton, setShowTestButton] = useState(false);
  const [exportedToPDF, setExportedToPDF] = useState(false);
  const [linkingWallet, setLinkingWallet] = useState(false);

  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);
  const [finalizacaoTipo, setFinalizacaoTipo] = useState(null); // 'semDespedida' ou 'comDespedida'
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false);
  const [requireQueueSelect, setRequireQueueSelect] = useState(false);

  // Estados para copiar telefone e respostas rápidas
  const [quickMessageModalOpen, setQuickMessageModalOpen] = useState(false);
  const isGroup = Boolean(
    ticket?.isGroup ||
    ticket?.status === "group" ||
    contact?.isGroup ||
    ticket?.contact?.isGroup ||
    contact?.remoteJid?.endsWith("@g.us") ||
    ticket?.contact?.remoteJid?.endsWith("@g.us")
  );
  const isTicketOwner = !ticket?.userId || ticket?.userId === user?.id;
  const isAdmin = user?.profile === "admin";
  const canManageTicket = isTicketOwner || isAdmin;

  useEffect(() => {
    fetchData();
    checkWhatsAppTriggerIntegration();
    fetchDirectTicketsToWalletsSetting();
    fetchAlwaysSelectQueueOnAcceptSetting();

    // Cleanup function to set isMounted to false when the component unmounts
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchData = async () => {
    const companyId = user.companyId;
    const planConfigs = await getPlanCompany(undefined, companyId);
    if (isMounted.current) {
      setShowSchedules(planConfigs.plan.useSchedules);
      setOpenTicketMessageDialog(false);
      setDisableBot(ticket.contact.disableBot);
      setShowTicketLogOpen(false);
    }
  };

  const checkWhatsAppTriggerIntegration = async () => {
    // Não verificar integração para tickets sem whatsappId (como WebChat)
    if (!ticket.whatsappId) {
      if (isMounted.current) {
        setShowTestButton(false);
      }
      return;
    }

    try {
      const { data } = await api.get(`/whatsapp/${ticket.whatsappId}`);
      if (isMounted.current) {
        setShowTestButton(data.triggerIntegrationOnClose === true);
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setShowTestButton(false);
      }
    }
  };

  const fetchDirectTicketsToWalletsSetting = async () => {
    try {
      const setting = await getSetting({
        column: "DirectTicketsToWallets"
      });
      if (isMounted.current) {
        setDirectTicketsToWallets(setting.DirectTicketsToWallets);
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setDirectTicketsToWallets(false);
      }
    }
  };

  const fetchAlwaysSelectQueueOnAcceptSetting = async () => {
    try {
      const setting = await getSetting({
        column: "alwaysSelectQueueOnAccept"
      });
      if (isMounted.current) {
        setRequireQueueSelect(setting.alwaysSelectQueueOnAccept === "enabled");
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setRequireQueueSelect(false);
      }
    }
  };

  // Função para copiar telefone
  const handleCopyPhone = async () => {
    try {
      if (!contact?.number) {
        toastUtils.error(i18n.t("ticketInfo.noPhone"), "Número Indisponível");
        return;
      }

      // Buscar o prefixo das configurações da empresa
      let prefix = "";
      try {
        const prefixSetting = await getSetting({
          column: "copyContactPrefix"
        });
        prefix = prefixSetting?.copyContactPrefix || "";
      } catch (err) {
        console.warn('Erro ao buscar prefixo de contato:', err);
        // Continua sem prefixo se houver erro
      }
  
      // Remove todos os caracteres não numéricos
      let phoneNumber = contact.number.replace(/\D/g, '');
      
      // Se o número começar com 55 (código do Brasil), remove
      if (phoneNumber.startsWith('55')) {
        phoneNumber = phoneNumber.substring(2);
      }
      
      // Remove o DDD (2 primeiros dígitos) se ainda tiver mais de 8 dígitos
      if (phoneNumber.length > 8) {
        phoneNumber = phoneNumber.substring(2);
      }
      
      // Se ainda tiver mais de 8 dígitos (nono dígito), remove o primeiro dígito
      if (phoneNumber.length > 8) {
        phoneNumber = phoneNumber.substring(1);
      }
      
      // Verifica se tem exatamente 8 dígitos
      if (phoneNumber.length === 8) {
        // Monta o texto final com prefixo + número
        const finalText = prefix ? `${prefix}${phoneNumber}` : phoneNumber;
        
        await navigator.clipboard.writeText(finalText);
        toastUtils.success(
          prefix ? 
            `Telefone copiado com prefixo: ${finalText}` : 
            i18n.t("ticketInfo.phonecopied"), 
          "Telefone Copiado"
        );
      } else {
        toastUtils.error(i18n.t("ticketInfo.invalidPhoneFormat"), "Formato Inválido");
      }
    } catch (err) {
      console.error('Erro ao copiar telefone:', err);
      toastUtils.error(i18n.t("ticketInfo.copyError"), "Erro ao Copiar");
    }
  };

  // Funções para respostas rápidas
  const handleOpenQuickMessageModal = () => {
    setQuickMessageModalOpen(true);
  };

  const handleCloseQuickMessageModal = () => {
    setQuickMessageModalOpen(false);
  };

  const handleQuickMessageSelect = useCallback((selectedMessage) => {
    handleCloseQuickMessageModal();
    
    if (selectedMessage.mediaPath) {
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: selectedMessage.mediaPath,
            mediaType: selectedMessage.mediaType,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });
      
      window.dispatchEvent(event);
    } else {
      // Para texto, também usar evento
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: null,
            mediaType: null,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });
      
      window.dispatchEvent(event);
    }
  }, []);

  const handleClickOpen = async (e) => {
    const setting = await getSetting({
      column: "requiredTag",
    });

    if (setting?.requiredTag === "enabled") {
      //verificar se tem uma tag
      try {
        const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
        if (!contactTags.data.tags) {
          toastUtils.warning(i18n.t("messagesList.header.buttons.requiredTag"), "Tag Obrigatória");
        } else {
          setOpen(true);
          // handleUpdateTicketStatus(e, "closed", user?.id);
        }
      } catch (err) {
        toastError(err);
      }
    } else {
      setOpen(true);
      // handleUpdateTicketStatus(e, "closed", user?.id);
    }
  };

  const handleClose = () => {
    formRef.current.resetForm();
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setLoading(false);
  };
  const handleOpenAcceptTicketWithouSelectQueue = async () => {
    setAcceptTicketWithouSelectQueueOpen(true);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenTransferModal = (e) => {
    setTransferTicketModalOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleCloseTicketWithoutFarewellMsg = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "closed",
        userId: user?.id || null,
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
      });

      setLoading(false);
      history.push("/tickets");
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleExportPDF = async () => {
    setOpenTicketMessageDialog(true);
    handleCloseMenu();
  };

  const handleEnableIntegration = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        useIntegration: !enableIntegration,
      });
      setEnableIntegration(!enableIntegration);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleShowLogTicket = async () => {
    setShowTicketLogOpen(true);
  };

  const handleContactToggleDisableBot = async () => {
    const { id } = ticket.contact;

    try {
      const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
      ticket.contact.disableBot = data.disableBot;
      setDisableBot(data.disableBot);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  const handleDeleteTicket = async () => {
    try {
      if (isGroup && (ticket.contactId || ticket.contact?.id)) {
        await api.delete(`/contacts/groups/${ticket.contactId || ticket.contact.id}`);
      } else {
        await api.delete(`/tickets/${ticket.id}`);
      }
      history.push("/tickets");
    } catch (err) {
      toastError(err);
    }
  };

  const handleUnassignGroup = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "group",
        userId: null,
      });
      toastUtils.success(
        `Atendente removido do grupo com sucesso! Agora todos podem visualizar.`,
        "Grupo Desatribuído"
      );
      handleCloseMenu();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleSendMessage = async (id) => {
    let setting;

    try {
      setting = await getSetting({
        column: "greetingAcceptedMessage",
      });
    } catch (err) {
      toastError(err);
    }
    if (!setting.greetingAcceptedMessage) {
      toastUtils.warning(
        i18n.t("messagesList.header.buttons.greetingAcceptedMessage"),
        "Mensagem de Aceitação"
      );
      return;
    }
    const msg = `${setting.greetingAcceptedMessage}`;
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleUpdateTicketStatus = async (e, status, userId) => {
    setLoading(true);
    try {
      // Verificar limite de tickets antes de aceitar
      if (status === "open" && userId) {
        const ticketLimitCheck = await canAcceptTicket();
        if (!ticketLimitCheck.canAccept) {
          toastUtils.error(ticketLimitCheck.reason || "Não é possível aceitar mais tickets", "Limite de Tickets");
          setLoading(false);
          return;
        }
      }

      await api.put(`/tickets/${ticket.id}`, {
        status: status,
        userId: userId || null,
      });

      let setting;

      try {
        setting = await getSetting({
          column: "sendGreetingAccepted",
        });
      } catch (err) {
        toastError(err);
      }

      // Mensagem de aceite agora é enviada automaticamente pelo backend
      // if (
      //   setting?.sendGreetingAccepted === "enabled" &&
      //   (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") &&
      //   ticket.status === "pending"
      // ) {
      //   handleSendMessage(ticket.id);
      // }

      if (isMounted.current) {
        setLoading(false);
      }

      if (status === "open" || status === "group") {
        setCurrentTicket({ ...ticket, code: "#" + status });
        setTimeout(() => {
          history.push("/tickets");
        }, 0);

        setTimeout(() => {
          history.push(`/tickets/${ticket.uuid}`);
          setTabOpen(status);
        }, 10);
      } else {
        setCurrentTicket({ id: null, code: null });
        history.push("/tickets");
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      toastError(err);
    }
  };

  const handleAcepptTicket = async (id) => {
    setLoading(true);
    try {
      const otherTicket = await api.put(`/tickets/${id}`, {
        status: ticket.isGroup ? "group" : "open",
        userId: user?.id,
      });
      if (otherTicket.data.id !== ticket.id) {
        if (otherTicket.data.userId !== user?.id) {
          if (isMounted.current) {
            setOpenAlert(true);
            setUserTicketOpen(otherTicket.data.user.name);
            setQueueTicketOpen(otherTicket.data.queue.name);
            setTabOpen(otherTicket.isGroup ? "group" : "open");
          }
        } else {
          if (isMounted.current) {
            setLoading(false);
            setTabOpen(otherTicket.isGroup ? "group" : "open");
          }
          history.push(`/tickets/${otherTicket.data.uuid}`);
        }
      } else {
        if (isMounted.current) {
          setLoading(false);
        }
        history.push("/tickets");
        setTimeout(() => {
          history.push(`/tickets/${ticket.uuid}`);
          setTabOpen(ticket.isGroup ? "group" : "open");
        }, 1000);
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      toastError(err);
    }
  };


  const handleTestButton = async () => {
    try {
      if (ticket?.whatsapp?.integrationTypeId) {
        const { data: integration } = await api.get(
          `/queueIntegration/${ticket.whatsapp.integrationTypeId}`
        );

        if (integration) {
          await api.post(`/queueIntegration/testsession`, {
            integrationId: ticket.whatsapp.integrationTypeId,
            ticketId: ticket.id,
            contactId: ticket.contactId,
            body: ticket.lastMessage?.body || "",
            status: "closed",
          });

          if (isMounted.current) {
            toastUtils.success(i18n.t("ticketList.success.integrationTriggered"), "Integração Acionada");
          }
        }
      }

      await handleUpdateTicketStatus(
        null,
        "closed",
        user?.id,
        ticket?.queue?.id
      );

      if (isMounted.current) {
        handleClose();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleLinkToWallet = async () => {
    if (!ticket.contactId) {
      toastUtils.error(i18n.t("contactModal.saveFirst"), "Salvar Primeiro");
      return;
    }

    setLinkingWallet(true);
    try {
      if (!user.queues || user.queues.length === 0) {
        toastUtils.error(i18n.t("contactModal.walletError"), "Erro na Carteira");
        return;
      }

      // Usa a primeira fila do usuário
      const userQueue = user.queues[0];

      await api.put(`/contacts/wallet/${ticket.contactId}`, {
        wallets: {
          userId: user.id,
          queueId: ticket.queueId || userQueue.id,
        },
      });

      toastUtils.success(i18n.t("contactModal.walletLinked"), "Carteira Vinculada");
    } catch (err) {
      toastError(err);
    } finally {
      setLinkingWallet(false);
    }
  };

  const handleToggleMute = async (e) => {
    if (e) e.stopPropagation();
    handleCloseMenu();
    try {
      const isMuted = !Boolean(ticket.isMuted);
      await api.put(`/tickets/${ticket.id}/mute`, { isMuted });
      toastUtils.success(
        isMuted ? "Silenciado" : "Reativado",
        isMuted ? "Notificações silenciadas." : "Notificações reativadas."
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleFinalizarTicket = async (tipo) => {
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
      setFinalizacaoTipo(tipo);
      setOpenFinalizacaoVenda(true);
    } else {
      if (tipo === "semDespedida") {
        handleCloseTicketWithoutFarewellMsg();
      } else {
        handleUpdateTicketStatus(null, "closed", user?.id, ticket?.queue?.id);
      }
    }
  };

  const handleClickResolver = () => {
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
      setFinalizacaoTipo("comDespedida");
      setOpenFinalizacaoVenda(true);
    } else {
      setOpen(true);
    }
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
      });
      toastUtils.success("Ticket finalizado com sucesso!", "Ticket Finalizado");
      // Atualize o estado conforme necessário
    } catch (err) {
      toastError(err);
    }
  };

  // Tooltip dinâmico para copiar telefone
  const getCopyPhoneTooltip = () => {
    return "Copiar telefone (com prefixo se configurado)";
  };

  return (
    <>
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {showTicketLogOpen && (
        <ShowTicketLogModal
          isOpen={showTicketLogOpen}
          handleClose={(e) => setShowTicketLogOpen(false)}
          ticketId={ticket.id}
          isGroup={isGroup}
        />
      )}
      
      {quickMessageModalOpen && (
  <QuickMessageModal
    open={quickMessageModalOpen}
    onClose={handleCloseQuickMessageModal}
    onSelect={handleQuickMessageSelect}
    companyId={user?.companyId}
    userId={user?.id}
  />
)}

      <div className={classes.actionButtons}>
        {!isGroup && ticket.status === "closed" &&
          (ticket.queueId === null || ticket.queueId === undefined) && (
            <ButtonWithSpinner
              loading={loading}
              startIcon={<Replay />}
              size="small"
              onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
            >
              {i18n.t("messagesList.header.buttons.reopen")}
            </ButtonWithSpinner>
          )}
        {!isGroup && ticket.status === "closed" && ticket.queueId !== null && (
          <ButtonWithSpinner
            startIcon={<Replay />}
            loading={loading}
            onClick={(e) => handleAcepptTicket(ticket.id)}
          >
            {i18n.t("messagesList.header.buttons.reopen")}
          </ButtonWithSpinner>
        )}

        {isGroup ? (
          <>
            {/* Ícone para respostas rápidas */}
            <IconButton 
              className={classes.bottomButtonVisibilityIcon}
              onClick={handleOpenQuickMessageModal}
            >
              <Tooltip title={i18n.t("ticketInfo.quickMessages")}>
                <FlashOn />
              </Tooltip>
            </IconButton>

            {/* Resumo do Grupo por IA - exclusivo para grupos */}
            <IconButton 
              className={classes.bottomButtonVisibilityIcon}
              onClick={() => setGroupSummaryModalOpen(true)}
            >
              <Tooltip title="Resumo do Grupo (IA)">
                <AssessmentIcon />
              </Tooltip>
            </IconButton>

            {onOpenDrawer && (
              <IconButton 
                className={classes.bottomButtonVisibilityIcon}
                onClick={onOpenDrawer}
              >
                <Tooltip title="Participantes do Grupo">
                  <GroupIcon />
                </Tooltip>
              </IconButton>
            )}

            {/* Desatribuir Atendente - só aparece se o grupo tem atendente atribuído */}
            {ticket.userId && (
              <IconButton 
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleUnassignGroup}
                disabled={loading}
                style={{ color: "#e65100" }}
              >
                <Tooltip title={`Desatribuir Atendente${ticket.user?.name ? ` (${ticket.user.name})` : ""}`}>
                  <PersonAddDisabledIcon />
                </Tooltip>
              </IconButton>
            )}
          </>
        ) : (
          ticket.status === "open" && (
            <>
              {/* Botão de alternância Ligar/Desligar Chat (Modo Observador) */}
              {isOtherUserTicket && (
                <Tooltip title={chatUnlocked ? "Chat Ligado: Digitação liberada para intervir. Clique para Desligar (Modo Observador)" : "Chat Desligado: Modo Observador ativo. Clique para Ligar / Intervir"}>
                  <Button
                    size="small"
                    variant={chatUnlocked ? "contained" : "outlined"}
                    onClick={onToggleChatLock}
                    startIcon={chatUnlocked ? <LockOpenIcon style={{ fontSize: 16 }} /> : <VisibilityIcon style={{ fontSize: 16 }} />}
                    style={{
                      height: 32,
                      borderRadius: 16,
                      textTransform: "none",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      backgroundColor: chatUnlocked ? "#e65100" : "transparent",
                      color: chatUnlocked ? "#fff" : "#e65100",
                      borderColor: "#e65100",
                      marginRight: 6,
                    }}
                  >
                    {chatUnlocked ? "Chat Ligado" : "Chat Desligado"}
                  </Button>
                </Tooltip>
              )}

              {/* Ícone para copiar telefone */}
              <IconButton 
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleCopyPhone}
                disabled={!contact?.number}
              >
                <Tooltip title={getCopyPhoneTooltip()}>
                  <FileCopyIcon />
                </Tooltip>
              </IconButton>

              {/* Ícone para respostas rápidas */}
              <IconButton 
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleOpenQuickMessageModal}
              >
                <Tooltip title={i18n.t("ticketInfo.quickMessages")}>
                  <FlashOn />
                </Tooltip>
              </IconButton>

              {/* Voice Assistant Button */}
              <VoiceAssistantButton 
                ticket={ticket}
                contact={contact}
              />

              {/* Botões restritos ao atendente titular ou administrador */}
              {canManageTicket && (
                <>
                  <IconButton className={classes.bottomButtonVisibilityIcon}>
                    <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                      <HighlightOffIcon onClick={handleClickResolver} />
                    </Tooltip>
                  </IconButton>

                  <IconButton className={classes.bottomButtonVisibilityIcon}>
                    <Tooltip title={i18n.t("tickets.buttons.returnQueue")}>
                      <UndoIcon
                        onClick={(e) =>
                          handleUpdateTicketStatus(e, "pending", null)
                        }
                      />
                    </Tooltip>
                  </IconButton>

                  <IconButton className={classes.bottomButtonVisibilityIcon}>
                    <Tooltip title="Transferir Ticket">
                      <SwapHorizOutlined
                        onClick={handleOpenTransferModal}
                      />
                    </Tooltip>
                  </IconButton>
                </>
              )}

              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={() => setParticipantsModalOpen(true)}
              >
                <Tooltip title="Participantes / Co-atendimento">
                  <Badge
                    badgeContent={
                      ticket.participants?.filter((p) => p.status === "accepted").length || 0
                    }
                    color="primary"
                  >
                    <GroupIcon />
                  </Badge>
                </Tooltip>
              </IconButton>

              {/* Botão de vincular à carteira só aparece se for titular/admin E não houver carteira vinculada E DirectTicketsToWallets ativo */}
              {canManageTicket && directTicketsToWallets && !(
                ticket.contact?.contactWallets &&
                ticket.contact.contactWallets.length > 0
              ) && (
                <IconButton
                  className={classes.bottomButtonVisibilityIcon}
                  onClick={handleLinkToWallet}
                  disabled={linkingWallet}
                >
                  <Tooltip title="Vincular à minha carteira">
                    {linkingWallet ? (
                      <CircularProgress size={20} />
                    ) : (
                      <AccountBalanceWallet />
                    )}
                  </Tooltip>
                </IconButton>
              )}

              {canManageTicket && (
                <MenuItem className={classes.bottomButtonVisibilityIcon}>
                  <Tooltip title={i18n.t("contactModal.form.chatBotContact")}>
                    <Switch
                      size="small"
                      checked={disableBot}
                      onChange={() => handleContactToggleDisableBot()}
                    />
                  </Tooltip>
                </MenuItem>
              )}
            </>
          )
        )}

        {!isGroup && ticket.status === "pending" &&
          (requireQueueSelect || ticket.queueId === null || ticket.queueId === undefined) && (
            <ButtonWithSpinner
              loading={loading}
              size="small"
              variant="contained"
              onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
            >
              {i18n.t("messagesList.header.buttons.accept")}
            </ButtonWithSpinner>
          )}
        {!isGroup && ticket.status === "pending" && !requireQueueSelect && ticket.queueId !== null && (
          <ButtonWithSpinner
            loading={loading}
            size="small"
            variant="contained"
            onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
          >
            {i18n.t("messagesList.header.buttons.accept")}
          </ButtonWithSpinner>
        )}
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
          style={{ paddingHorizontal: 3, paddingTop: 10 }}
        >
          <MoreVert style={{ fontSize: 16, padding: 0 }} />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleCloseMenu}
        >
          <Can
            role={user.profile}
            perform="ticket-options:deleteTicket"
            yes={() => (
              canManageTicket && (
                <MenuItem onClick={handleOpenConfirmationModal}>
                  {isGroup ? "Deletar Grupo" : i18n.t("tickets.buttons.deleteTicket")}
                </MenuItem>
              )
            )}
          />
          {!isGroup && canManageTicket && (
            <MenuItem onClick={handleEnableIntegration}>
              {enableIntegration === true
                ? i18n.t("messagesList.header.buttons.disableIntegration")
                : i18n.t("messagesList.header.buttons.enableIntegration")}
            </MenuItem>
          )}
          <MenuItem onClick={handleToggleMute}>
            {ticket.isMuted ? (
              <NotificationsActiveIcon fontSize="small" style={{ color: "#4caf50", marginRight: 8 }} />
            ) : (
              <NotificationsOffIcon fontSize="small" style={{ color: "#f44336", marginRight: 8 }} />
            )}
            {ticket.isMuted ? "Reativar notificações" : "Silenciar notificações"}
          </MenuItem>
          <MenuItem onClick={handleShowLogTicket}>
            {isGroup ? "Logs do Grupo" : i18n.t("messagesList.header.buttons.logTicket")}
          </MenuItem>
          <MenuItem onClick={handleExportPDF}>
            {i18n.t("ticketsList.buttons.exportAsPDF")}
          </MenuItem>
          {isGroup && ticket.userId && (
            <MenuItem
              onClick={handleUnassignGroup}
              style={{ color: "#e65100" }}
            >
              {`Desatribuir Atendente${ticket.user?.name ? ` (${ticket.user.name})` : ""}`}
            </MenuItem>
          )}
        </Menu>
      </div>

      {confirmationOpen && (
        <ConfirmationModal
          title={
            isGroup
              ? `Deletar Grupo #${ticket.id}?`
              : `${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`
          }
          open={confirmationOpen}
          onClose={setConfirmationOpen}
          onConfirm={handleDeleteTicket}
        >
          {isGroup
            ? "Tem certeza que deseja deletar este grupo do sistema? O histórico de mensagens deste atendimento será removido."
            : i18n.t("ticketOptionsMenu.confirmationModal.message")}
        </ConfirmationModal>
      )}
      {transferTicketModalOpen && (
        <TransferTicketModalCustom
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferTicketModal}
          ticketid={ticket.id}
          ticket={ticket}
        />
      )}
      {participantsModalOpen && (
        <TicketParticipantsModal
          open={participantsModalOpen}
          onClose={() => setParticipantsModalOpen(false)}
          ticket={ticket}
        />
      )}
      {groupSummaryModalOpen && (
        <GroupSummaryModal
          open={groupSummaryModalOpen}
          onClose={() => setGroupSummaryModalOpen(false)}
          ticket={ticket}
        />
      )}

      <>
        {(!user.finalizacaoComValorVendaAtiva ||
          user.finalizacaoComValorVendaAtiva === false ||
          user.finalizacaoComValorVendaAtiva === "false") && (
          <Formik
            enableReinitialize={true}
            validationSchema={SessionSchema}
            innerRef={formRef}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                actions.setSubmitting(false);
                actions.resetForm();
              }, 400);
            }}
          >
            {({
              values,
              touched,
              errors,
              isSubmitting,
              setFieldValue,
              resetForm,
            }) => (
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <Form>
                  <DialogActions className={classes.botoes}>
                    <Button
                      onClick={() => handleFinalizarTicket("semDespedida")}
                      style={{
                        background: theme.palette.primary.main,
                        color: "white",
                      }}
                    >
                      {i18n.t(
                        "messagesList.header.dialogRatingWithoutFarewellMsg"
                      )}
                    </Button>

                    <Button
                      onClick={() => handleFinalizarTicket("comDespedida")}
                      style={{
                        background: theme.palette.primary.main,
                        color: "white",
                      }}
                    >
                      {i18n.t("messagesList.header.dialogRatingCancel")}
                    </Button>

                    {showTestButton && (
                      <Button
                        onClick={handleTestButton}
                        style={{
                          background: theme.palette.primary.main,
                          color: "white",
                        }}
                      >
                        {i18n.t(
                          "whatsappModalRel.form.resolveAndTriggerIntegration"
                        )}
                      </Button>
                    )}
                  </DialogActions>
                </Form>
              </Dialog>
            )}
          </Formik>
        )}
      </>
      {openFinalizacaoVenda && (
          <FinalizacaoVendaModal
            open={openFinalizacaoVenda}
            onClose={() => setOpenFinalizacaoVenda(false)}
            ticket={ticket}
            onFinalizar={(ticketData) => {
              setOpenFinalizacaoVenda(false);
              setTicketDataToFinalize(ticketData);
              setShowFinalizacaoOptions(true);
            }}
          />
        )}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions className={classes.botoes}>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default TicketActionButtonsCustom;